import { render, staticRenderFns } from "./InfoTab.vue?vue&type=template&id=762cad00&scoped=true&"
import script from "./InfoTab.vue?vue&type=script&lang=js&"
export * from "./InfoTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762cad00",
  null
  
)

export default component.exports